module.exports = __webpack_public_path__ + "img/32.079137a1.png";